import { Chess } from "chess.js";
import { PgnMove } from "./PgnMove";
import { NAG_VALUES } from "./Nag";
import { PgnData } from "./PgnData";
import { PgnParser } from "./PgnParser";
export class PgnDataBuilder {
    pgn;
    chess;
    _pgnData = null;
    constructor(pgn, chess = null) {
        if (!pgn || typeof pgn !== "string") {
            throw new Error("Invalid PGN format: PGN must be a non-empty string");
        }
        this.pgn = PgnParser.normalize(pgn.trim());
        this.chess = chess || new Chess();
        if (!PgnParser.isValidPgn(this.pgn)) {
            throw new Error("Invalid PGN format: PGN must contain moves or a valid FEN");
        }
    }
    pgnData() {
        if (this._pgnData)
            return this._pgnData;
        this._pgnData = PgnData.create(this.pgn, this.chess, this);
        return this._pgnData;
    }
    parseMoves() {
        const moves = [];
        let currentMove = null;
        let preGameComment;
        const variationStack = [];
        const initialFen = PgnParser.extractInitialFen(this.pgn);
        const chess = this.chess;
        chess.load(initialFen);
        const tokens = PgnParser.tokenizeMoves(this.pgn);
        let moveNumber = 1;
        let isPuzzleMove = false;
        for (let i = 0; i < tokens.length; i++) {
            const token = tokens[i];
            if (token === "(") {
                if (!currentMove)
                    continue;
                variationStack.push({
                    moves: [],
                    parentMove: currentMove,
                });
                // load fen before the current move
                chess.undo();
                currentMove = currentMove.previousMove;
                continue;
            }
            if (token === ")") {
                const variation = variationStack.pop();
                if (!variation)
                    continue;
                // Restore position from before variation
                currentMove = variation.parentMove;
                chess.load_pgn(currentMove.pgn.replace(/\n\n\d+\.\s/, "\n1. "));
                continue;
            }
            // Skip move numbers and move number continuations
            if (PgnParser.REGEX.MOVE_NUMBER.test(token)) {
                moveNumber = parseInt(token.match(PgnParser.REGEX.MOVE_NUMBER_EXTRACT)[0]);
                continue;
            }
            if (token === "*") {
                // unfinished game
                continue;
            }
            if (token === PgnParser.REGEX.PUZZLE_MARKER) {
                isPuzzleMove = true;
                continue;
            }
            // if token match user score, set currentMove userScore
            if (PgnParser.REGEX.USER_SCORE.test(token)) {
                if (currentMove) {
                    const score = parseInt(token.match(PgnParser.REGEX.USER_SCORE_EXTRACT)[1]);
                    currentMove.loadUserScore(score);
                    if (score < 0 && currentMove.isPuzzleMove) {
                        currentMove.setIsPuzzleMove(false);
                    }
                }
                continue;
            }
            if (PgnParser.REGEX.COMMENT.test(token)) {
                const comment = token.replace(/^\{|\}$/g, "");
                if (currentMove) {
                    if (currentMove.comment) {
                        currentMove.updateComment(`${currentMove.comment}\n${comment}`);
                    }
                    else {
                        currentMove.updateComment(comment);
                    }
                }
                else {
                    // Handle pre-game comment
                    if (preGameComment) {
                        preGameComment += `\n${comment}`;
                    }
                    else {
                        preGameComment = comment;
                    }
                }
                continue;
            }
            // Check if token is a NAG
            if (NAG_VALUES.includes(token)) {
                if (currentMove) {
                    currentMove.updateNag(token);
                }
                continue;
            }
            if (PgnParser.REGEX.NAG_ANNOTATION.test(token)) {
                // annotations
                continue;
            }
            if (token.trim() === "") {
                continue;
            }
            const variation = variationStack.length > 0
                ? variationStack[variationStack.length - 1]
                : null;
            const move = new PgnMove(token, chess, currentMove, variation && variation.moves.length === 0 ? variation.parentMove : null, initialFen);
            if (!move.id) {
                continue;
            }
            if (move.number !== moveNumber) {
                console.error(`Invalid move number ${move.number} for move ${move.id}`);
            }
            if (isPuzzleMove) {
                move.setIsPuzzleMove(true);
            }
            if (variation) {
                variation.moves.push(move);
            }
            else {
                moves.push(move);
            }
            // Check if the token contains a NAG by comparing with the move's SAN
            if (token !== move.san && token.startsWith(move.san)) {
                const possibleNag = token.slice(move.san.length);
                if (NAG_VALUES.includes(possibleNag)) {
                    move.updateNag(possibleNag);
                }
            }
            currentMove = move;
        }
        return {
            rootMove: moves.length > 0 ? moves[0] : null,
            preGameComment,
        };
    }
}
